export interface PSSRFile {
  Id: number;
  File: string;
  FileType: number;
  PSSRID: number;
  GUID: string | null;
  Description: string;
  CreateDate: Date;
  ContentType: string | null;
  IsImage: boolean;
  SelectedPages?: number[];
}

export const PSSRFileConstants = {
  validImageExtensions: ['image/gif', 'image/png', 'image/jpg', 'image/jpeg', 'image/bmp'],
  validBinaryExtensions: [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/msword',
    'application/vnd.ms-excel',
    'application/octet-stream',
    'application/pdf',
    'video/mp4',
    'application/acad',
    'application/x-dwf',
  ],
  get acceptableExtensions() {
    return [...this.validImageExtensions, ...this.validBinaryExtensions].join();
  },
};
